import { Map } from 'immutable';

import { isValidNumber } from '../../../number';

import { ERROR, VALUE } from '../../../../constants/product';
import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { EMPTY } from '../../../../constants';
import { FAIRE } from '../../../../constants/channels';

export function sellingMethod({ preview }) {
  function reduceShippingAttributes(operations, values, attribute) {
    switch (attribute) {
      case ATTRIBUTE.CASE_SIZE: {
        if (!values.get(ERROR)) {
          operations.unshift(
            Map({
              type: OPERATIONS[FAIRE].CASE_SIZE.SET,
              value: isValidNumber(values.get(VALUE)) ? parseInt(values.get(VALUE)) : null,
            })
          );
        }

        break;
      }

      case ATTRIBUTE.MINIMUM_ORDER_QUANTITY: {
        if (!values.get(ERROR)) {
          operations.push(
            Map({
              type: OPERATIONS[FAIRE].MINIMUM_ORDER_QUANTITY.SET,
              value: isValidNumber(values.get(VALUE)) ? parseInt(values.get(VALUE)) : null,
            })
          );
        }

        break;
      }

      case ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY: {
        if (!values.get(ERROR)) {
          operations.unshift(
            Map({
              type: OPERATIONS[FAIRE].PER_STYLE_MINIMUM_ORDER_QUANTITY.SET,
              value: isValidNumber(values.get(VALUE)) ? parseInt(values.get(VALUE)) : null,
            })
          );
        }

        break;
      }

      default: {
        break;
      }

    }

    return operations;
  }

  return { payload: preview.get(ATTRIBUTE.SHIPPING, EMPTY.MAP).reduce(reduceShippingAttributes, []) };
}
